import { cn } from '@wellesley/ui'
import { FC } from 'react'
import { Check } from 'lucide-react'

type StageItemProps = {
  isActive?: boolean
  isCompleted?: boolean
  position: number
  title: string
}
const StageItem: FC<StageItemProps> = ({
  isActive,
  isCompleted,
  position,
  title,
}) => {
  return (
    <div className="flex flex-col items-center">
      <div
        className={cn('flex size-xs items-center justify-center rounded-full', {
          'bg-blue-500 text-white': isActive,
          'bg-green-600 text-white': isCompleted,
          'bg-gray-100 text-gray-500': !isActive && !isCompleted,
        })}
      >
        {isCompleted ? (
          <Check size={16} color="white" />
        ) : (
          <span className="text-sm font-semibold">{position}</span>
        )}
      </div>
      <div
        className={cn('mt-2.5', {
          'text-sm font-semibold text-gray-900': isActive,
          'text-base font-medium text-gray-400': !isActive,
        })}
      >
        {title}
      </div>
    </div>
  )
}

type SignUpStagesViewProps = {
  list: Omit<StageItemProps, 'position'>[]
  className?: string
}
export const SignUpStagesView: FC<SignUpStagesViewProps> = ({
  list,
  className,
}) => {
  return (
    <div
      className={cn('mx-auto mb-s flex w-[450px] justify-between', className)}
    >
      {list.map((item, index) => (
        <>
          <StageItem key={item.title} position={index + 1} {...item} />
          {index < list.length - 1 && (
            <div className="mt-xs h-px w-full flex-1 bg-gray-200" />
          )}
        </>
      ))}
    </div>
  )
}
